const translations = {
  'mobile.warnings.answers': 'Answers',
  'mobile.warnings.invalid_age': 'You need to enter a valid date to proceed.',
  'mobile.warnings.single': 'You need to select an answer to proceed.',
  'mobile.warnings.multiple':
    'You need to select one or more answers to proceed.',
  'mobile.warnings.multiple_with_min': 'You need to select at least',
  'mobile.warnings.multiple_with_max': 'You cannot select more than',
  'mobile.warnings.rating': 'You need to tap on the Stars to rate and proceed.',
  'mobile.warnings.slider': 'You need to slide the button to rate and proceed.',
  'mobile.warnings.open_ended':
    'You need to type an answer in the box to proceed.',
  'mobile.warnings.other_open_ended':
    'You need to type an answer in the box to proceed.',
  'mobile.warnings.ranking': 'You need to rank all entries to proceed.',
  'mobile.warnings.numeric_open':
    'You need to type a number in the box to proceed.',
  'mobile.warnings.numeric_with_min': 'Your answer should be at least',
  'mobile.warnings.numeric_with_max': 'Your answer should be at most',
  'mobile.warnings.numeric_integer_only': 'Your answer should be an integer',
  'mobile.warnings.matrix_single':
    'You need to select a single answer per row to proceed.',
  'mobile.warnings.matrix_multiple':
    'You need to select at least one answer per row to proceed.',
  'mobile.warnings.matrix_bipolar':
    'You need to select a value per statement to proceed.',
  'mobile.warnings.nps': 'You need to tap on a number to rate and proceed.',
  'mobile.warnings.video': 'You need to finish watching the video to proceed.',
  'mobile.gift_indicator':
    'Apple, Google and Amazon are not a sponsor nor are involved in any way in this contest/draw. No Apple products are being used as prizes.',
  'mobile.opens_in_browser': 'Opens in browser',
  'mobile.anonymous_responses': 'Your responses are completely anonymous',
  'mobile.description': 'Description',
  'mobile.loading.title': 'Oops',
  'mobile.loading.subtitle': "You've been screened out",
  'mobile.loading.info': "We're looking for a new survey for you",
  'mobile.thank_you.subtitle': 'Job well done',
  'mobile.thank_you.no_survey_available.title': 'Wow',
  'mobile.thank_you.no_survey_available.subtitle':
    'Someone ate all the surveys!',
  'mobile.thank_you.no_survey_available.btn_copy': 'Close',
  'mobile.thank_you.incentive.already_email.title': 'Feel the love!',
  'mobile.thank_you.incentive.already_email.subtitle':
    'You will be entered into a drawing for a chance to win a $20 gift card!',
  'mobile.thank_you.incentive.already_email.btn_copy': 'Close the survey',
  'mobile.thank_you.incentive.already_email.hear_from_us':
    'You will hear from us via email if you win',
  'mobile.thank_you.incentive.new_email.title': 'Wait',
  'mobile.thank_you.incentive.new_email.subtitle': 'There is more',
  'mobile.thank_you.incentive.new_email.prompt':
    'Get in the draw for a $20 gift card',
  'mobile.thank_you.incentive.new_email.placeholder': 'Enter your email here',
  'mobile.thank_you.incentive.new_email.btn_copy': 'Submit and close',
  'mobile.thank_you.incentive.new_email.not_interested':
    'Thanks, not interested',
  'mobile.thank_you.non_incentive.title': 'Thank you',
  'mobile.thank_you.non_incentive.subtitle': 'Job well done',
  'mobile.thank_you.non_incentive.btn_copy': 'Close the survey',
  'mobile.errors.empty_email': 'Please enter your email address',
  'mobile.errors.wrong_email': 'Please enter a valid email address',
  'mobile.android_notification':
    "By accepting to take this survey a specific set of user's device data including information about the apps which the user has installed, is automatically sent to Pollfish servers and associated with answers to the questionnaires, in order for Pollfish to discern whether the user is eligible for a survey and improve targeting of future surveys.",
  'mobile.take_survey_btn': 'Start the survey',
  'mobile.no_thanks': 'No thanks',
  'mobile.notify_terms': 'Terms & Conditions',
  'mobile.by_taking_survey': 'By taking this survey you accept our',
  'mobile.ok_btn': 'OK',
  'mobile.choose_one': 'Select one',
  'mobile.choose_multiple': 'Select all that apply',
  'mobile.rate': 'Tap stars to rate',
  'mobile.date': 'Please enter your year of birth',
  'mobile.slider': 'Drag button to rate',
  'mobile.freeText': 'Please write in the box',
  'mobile.freeTextBox': 'Write your answer here',
  'mobile.rank': 'Tap button to rank',
  'mobile.matrix': 'Select one answer per row',
  'mobile.bipolar.matrix': 'Select a value per statement',
  'mobile.matrixMultiple': 'Select multiple answers per row',
  'mobile.matrixVanWestendorp': 'Please write in the box',
  'mobile.matrixVanWestendorp.warnings.missingValue':
    'You need to type a number in the box to proceed.',
  'mobile.matrixVanWestendorp.warnings.min':
    'The value must be greater than or equal to XXX',
  'mobile.matrixVanWestendorp.warnings.max':
    'The value must be less than or equal to XXX',
  'mobile.matrixVanWestendorp.warnings.orderAsc':
    'You need to provide a value which is greater than the previous one',
  'mobile.matrixVanWestendorp.warnings.orderDesc':
    'You need to provide a value which is less than the previous one',
  'mobile.matrixNumericOpenEnded': 'Please write in the boxes',
  'mobile.warnings.matrixNumericOpenEnded':
    'You need to type a number in the box to proceed.',
  'mobile.warnings.matrixNumericOpenEndedRange':
    'Your answers should be between XXX and YYY',
  'mobile.warnings.matrixNumericOpenEndedNote': 'Required fields',
  'mobile.warnings.matrixConstantSumOpenEndedNote':
    'Total per category must be: XXXX',
  'mobile.warnings.matrixConstantSumOpenEndedMustTotal':
    'You have to allocate XXXX for each category',
  'mobile.matrixConstantSumOpenEndedTotal': 'Total: YYYY (remaining: XXXX)',
  'mobile.matrixConstinousSumOpenEndedTotal': 'Total: YYYY',
  'mobile.if_you_win': 'Enter your email to get in the draw',
  'mobile.if_you_win_semiShort':
    'Submit your email to be entered into the draw',
  'mobile.if_you_win_has_email':
    'We will notify you through your email if you win',
  'mobile.close': 'Close the survey',
  'mobile.submit': 'Submit',
  'mobile.fillForm': 'Please fill the form!',
  'mobile.invalidEmail': 'Please enter a valid e-mail!',
  'mobile.scroll_down': 'Scroll down to proceed.',
  'mobile.back': 'Back',
  'mobile.notInterested': 'Not interested',
  'mobile.low': 'Low',
  'mobile.high': 'High',
  'mobile.answers': 'Answers',
  'mobile.least': 'Select at least',
  'mobile.selectNoMore': 'Select no more than',
  'mobile.noMore': 'and no more than',
  'mobile.surveyPrompt':
    'Answer a quick survey and get a chance to win a $20 amazon gift card.',
  'mobile.surveyPromptNoIncentive': 'Share your opinion on things that matter!',
  'mobile.NPSmin': 'Not at all likely',
  'mobile.NPSmax': 'Extremely likely',
  'mobile.noSurvey': 'There is no available survey',
  'mobile.inputAtLeast': 'Input should be at least',
  'mobile.inputNoMore': 'Input should be no more than',
  'mobile.gdpr.heading': 'Your Data',
  'mobile.gdpr.what_we_get_from_you_header': 'What we get from you',
  'mobile.gdpr.what_we_get_from_you_content':
    'Your survey answers and certain device data or response metadata. All anonymous, of course.',
  'mobile.gdpr.what_we_do_header': 'What we do with your data',
  'mobile.gdpr.what_we_do_content.survey_responses':
    'Provide survey responses to our clients',
  'mobile.gdpr.what_we_do_content.survey_eligibility':
    'Conclude if you are eligible to take a survey questionnaire',
  'mobile.gdpr.what_we_do_content.data_deduction':
    'Deduce statistical/socio-demographic data',
  'mobile.gdpr.what_you_need_to_know_header': 'What you need to know',
  'mobile.gdpr.what_you_need_to_know_content':
    "Pollfish is GDPR (General Data Protection Regulation) compliant. We share data only with our clients. By clicking I Agree you accept the processing of your data according to our <a href='#' class='js-terms'>ToU & Privacy Policy</a>.",
  'mobile.gdpr.footer': 'Your Call',
  'mobile.gdpr.i_will_not_participate': 'I will not participate in the survey',
  'mobile.gdpr.i_agree': 'I Agree',
  'mobile.withdraw_consent': 'Update my consent',
  'mobile.noMoreThan': 'and no more than',
  'mobile.surveyBy': 'Survey By',
  'mobile.screen_out.sanity.title': 'We needed more attention...',
  'mobile.screen_out.sanity.subtitle':
    'Unfortunately your responses failed to pass Pollfish quality controls. In future surveys, please try to read carefully the questions and consider all options prior submitting your answers.',
  'mobile.sanity_description':
    'Carefully read all the questions and consider all the options before submitting the correct answers. If you fail to pass our quality controls while completing the survey, the survey will be terminated immediately and you will be screened out.',
  'mobile.age.screen_out.subtitle':
    'You need to be at least X years old to be able to take surveys',
  'mobile.offerwall.points': 'Points',

  'mobile.offerwall.unlock_screen.title': 'Unlock surveys',
  'mobile.offerwall.unlock_screen.subtitle': 'by completing your profile',
  'mobile.offerwall.unlock_screen.btn_text': 'Get started',

  'mobile.offerwall.surveyCard.minutes': 'minutes ',
  'mobile.offerwall.surveyCard.top': 'Top',
  'mobile.offerwall.surveyCard.new': 'New',

  'mobile.offerwall.survey.load_more': 'Load more surveys',
  'mobile.offerwall.pull_to_refresh': 'Pull down to refresh',
  'mobile.offerwall.release_to_refresh': 'Release to refresh',
  'mobile.offerwall.survey.loading_more': 'Loading more surveys',
  'mobile.offerwall.survey.choose': 'Choose a survey to continue',
  'mobile.offerwall.survey.not_found.title':
    'Looks like we are all out of surveys for the moment',
  'mobile.offerwall.survey.not_found.subtitle': 'Please check back later',
  'mobile.offerwall.sort_by': 'Sort by',
  'mobile.offerwall.sort.highest_reward': 'Highest Reward',
  'mobile.offerwall.sort.whats_new': "What's New",
  'mobile.offerwall.sort.highest_rating': 'Highest Rating',
  'mobile.offerwall.sort.provider': 'Survey Provider',
  'mobile.offerwall.sort.loi': 'Length of Survey',
  'mobile.offerwall.sort.matching': 'Best Matching',
  'mobile.offerwall.notifications.disqualified':
    'Unfortunately your response got disqualified',
  'mobile.offerwall.notifications.pending':
    'Your response is pending verification',
  'mobile.offerwall.notifications.congratulations':
    'Congratulations, you have earned ...',
  'mobile.offerwall.notifications.feedback_thank_you':
    'Thank you for your feedback!',
  'mobile.offerwall.notifications.survey_closed':
    'Unfortunately that survey is no longer available!',
  'mobile.offerwall.history.24_hours': '24 Hours',
  'mobile.offerwall.history.30_days': '30 Days',
  'mobile.offerwall.history.survey_history': 'Survey History',
  'mobile.offerwall.history.pending': 'Pending',
  'mobile.offerwall.history.rewarded': 'Rewarded',
  'mobile.offerwall.history.screened_out': 'Screened out',
  'mobile.offerwall.history.quality': 'Quality',
  'mobile.offerwall.history.vpn': 'VPN',
  'mobile.offerwall.history.survey_expired': 'Survey expired',
  'mobile.offerwall.leaveSurvey.prompt': 'Leave survey?',
  'mobile.offerwall.leaveSurvey.title':
    "Once you leave this survey you won't be able to try it again. ",
  'mobile.offerwall.leaveSurvey.subtitle': 'Do you still want to leave?',

  'feedback.question_prompt': 'Tell us what happened',
  'feedback.answers.survey_page_error': 'The survey page had an error',
  'feedback.answers.personal_information': 'Asked for personal information',
  'feedback.answers.not_working_on_device': "Survey didn't work on my device",

  'mobile.offerwall.redirect.loading': 'Loading the survey',

  'mobile.thank_you_screen.rate': 'Rate this survey',
  'mobile.thank_you_screen.title': 'Thank you',
  'mobile.thank_you_screen.subtitle': 'We will review your responses soon',
  'mobile.thank_you_screen.optional': 'optional',
  'mobile.thank_you_screen.continue': 'Continue',
  'mobile.thank_you_screen.distribution_button_redirect': 'Done',
  'mobile.thank_you_screen.distribution_button_results': 'See results',

  'mobile.screen_out.title': 'Tough luck',
  'mobile.screen_out.subtitle':
    'You were not eligible for that survey, so no catnip for you',
  'mobile.eg': 'e.g.',
  'mobile.for_example': 'for example',
  'mobile.profileComplete': 'Profile complete',

  'mobile.offerwall.general.terms':
    "By accepting to take this survey, a specific set of user's device data, is automatically sent to Pollfish servers and associated with answers to the questionnaires, in order for Pollfish to discern whether the user is eligible for a survey and improve, targeting of future surveys.",
  'mobile.offerwall.error': 'Something went wrong!',
  'mobile.gdpr.what_data_header': 'What data do we collect and process?',
  'mobile.gdpr.what_data_list_title':
    'We collect and process (and associate-correlate):',
  'mobile.gdpr.what_data_option_one':
    'Your anonymous responses to the questionnaires presented to you',
  'mobile.gdpr.what_data_option_two':
    'Certain anonymous socio-demographic information about you',
  'mobile.gdpr.what_data_option_three':
    'Your Advertising and/or Device ID, only if you have enabled access (either through your system’s settings or via a consent-prompt shown to you by the publisher of the app you are using), to these.',
  'mobile.gdpr.what_data_text':
    'We are a US Company, GDPR compliant and Privacy Shield certified. Your data will be transferred to the US. ',
  'mobile.gdpr.with_whom': 'With whom we may share your Data?',
  'mobile.gdpr.with_whom_option_one': 'Researcher Clients',
  'mobile.gdpr.with_whom_option_two':
    'Mediation Platforms (i.e. third parties tendering their own surveys via Pollfish)',
  'mobile.gdpr.with_whom_option_three':
    'Other Clients, including Data Analysts, marketeers, Data brokers and advertisers. ',
  'mobile.gdpr.with_whom_text':
    'If you have enabled access to your Advertising and/or Device ID (either through your system’s settings or via a consent-prompt shown to you by the publisher of the app you are using), we may share these with Pollfish clients. Pollfish Clients may serve advertisements, conduct consumer profiling or target you online for their marketing campaigns.',
  'mobile.gdpr.managing_data_header': 'Managing your data and Opt-Out',
  'mobile.gdpr.managing_data_list_title': 'You can at all times opt-out:',
  'mobile.gdpr.managing_data_option_one':
    'From Pollfish sending you Surveys https://www.pollfish.com/respondent/opt-out',
  'mobile.gdpr.managing_data_option_two':
    'From Pollfish sharing your Personal Data with Clients for commercial purposes https://www.pollfish.com/do-not-sell-my-personal-information',
  'mobile.gdpr.processed_data_option_one':
    'I understand that my personal information will be processed outside of China, by Pollfish, in the following countries: USA and Greece.',
  'mobile.gdpr.processed_data_option_two':
    'I also understand that my personal information will be processed outside of China in countries, including USA and EU (as the case may be) where Pollfish Researcher Clients or Mediation Partners, having commissioned us with the distribution of their Surveys, may be seated. For further information you can contact Pollfish any time.',
  'mobile.gdpr.processed_data_option_three':
    'Further, I understand that my personal information will be processed outside of China in the following countries: USA, Canada, France, Romania, Israel, Pakistan and India by our Mediation Partner Toluna and its trustees IPGeo and IPQS.',
  'mobile.screen_out.vpn.title':
    'It looks like you are behind an anonymous proxy',
  'mobile.screen_out.vpn.subtitle':
    'We cannot accept responses while you are on this network',
  'mobile.screen_out.targeting.subtitle':
    'Looks like the market researcher is looking for a very specific candidate',
  'mobile.screen_out.payable.title': 'You deserve a reward for your time',
  'mobile.partial_reward': 'Partial reward',
  'mobile.schedule_offer.offer_ends': 'Offer ends in',
  'mobile.schedule_offer.rewards': 'Rewards',
  'mobile.warnings.max_decimals':
    'Your answer cannot have more than ΧΧΧX decimal places',
  'mobile.hide_answers_multimatrix_prompt': 'Hide answers',
  'mobile.postal_data.prefer_not_to_say': 'Prefer not to say',
  'mobile.screen_out.already_taken.subtitle':
    'You have already taken this survey',
  'mobile.screen_out.not_active.subtitle': 'This survey is not active',
  'mobile.warnings.openEndedMinLimit':
    'The answer should be at least XXX characters',
};

module.exports = translations;
